import { MdBlock, MdDownloadDone, MdLoop } from "react-icons/md";
import { defineMessage } from "react-intl";

/* Rental area bookings customer_type */
export const RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_PARTICULAR =
  "particular";
export const RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_COMPANY = "company";
export const RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_ASSOCIATION =
  "association";
export const RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_INSTITUTION =
  "institution";

/**
 * @type {Record<import("../../types/rentalArea/Booking").RentalAreaBookingCustomerType, {
 * id: import("../../types/rentalArea/Booking").RentalAreaBookingCustomerType;
 * label: import("react-intl").MessageDescriptor;
 * }>}
 */
export const RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPES = {
  [RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_PARTICULAR]: {
    id: RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_PARTICULAR,
    label: defineMessage({ defaultMessage: "particulier" }),
  },
  [RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_COMPANY]: {
    id: RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_COMPANY,
    label: defineMessage({ defaultMessage: "entreprise" }),
  },
  [RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_ASSOCIATION]: {
    id: RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_ASSOCIATION,
    label: defineMessage({ defaultMessage: "association" }),
  },
  [RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_INSTITUTION]: {
    id: RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_VALUE_INSTITUTION,
    label: defineMessage({ defaultMessage: "institution" }),
  },
};

export const RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPE_LIST = Object.values(
  RENTAL_AREAS_BOOKINGS_CUSTOMER_TYPES,
);

/* Rental area booking states */
export const RENTAL_AREAS_BOOKINGS_STATES_VALUE_PENDING = "pending";
export const RENTAL_AREAS_BOOKINGS_STATES_VALUE_CONFIRMED = "confirmed";
export const RENTAL_AREAS_BOOKINGS_STATES_VALUE_REFUSED = "refused";

/**
 * @type {Record<import("../../types/rentalArea/Booking").RentalAreaBookingState, {
 * id: import("../../types/rentalArea/Booking").RentalAreaBookingState;
 * label: import("react-intl").MessageDescriptor;
 * dateLabel: import("react-intl").MessageDescriptor;
 * icon: import("react-icons").IconType,
 * colors: [string, string],
 * }>}
 */
export const RENTAL_AREAS_BOOKINGS_STATES = {
  [RENTAL_AREAS_BOOKINGS_STATES_VALUE_PENDING]: {
    id: RENTAL_AREAS_BOOKINGS_STATES_VALUE_PENDING,
    label: defineMessage({ defaultMessage: "en attente" }),
    dateLabel: defineMessage({ defaultMessage: "créé le" }),
    icon: MdLoop,
    colors: ["orange.600", "orange.300"],
  },
  [RENTAL_AREAS_BOOKINGS_STATES_VALUE_CONFIRMED]: {
    id: RENTAL_AREAS_BOOKINGS_STATES_VALUE_CONFIRMED,
    label: defineMessage({ defaultMessage: "confirmée" }),
    dateLabel: defineMessage({ defaultMessage: "confirmée le" }),
    icon: MdDownloadDone,
    colors: ["green.600", "green.300"],
  },
  [RENTAL_AREAS_BOOKINGS_STATES_VALUE_REFUSED]: {
    id: RENTAL_AREAS_BOOKINGS_STATES_VALUE_REFUSED,
    label: defineMessage({ defaultMessage: "refusée" }),
    dateLabel: defineMessage({ defaultMessage: "refusée le" }),
    icon: MdBlock,
    colors: ["red.600", "red.300"],
  },
};

export const RENTAL_AREAS_BOOKINGS_STATES_LIST = Object.values(
  RENTAL_AREAS_BOOKINGS_STATES,
);

/* Rental area booking refusal reasons */
export const RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_CUSTOMER_CANCELLATION =
  "customer_cancellation";
export const RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_SYSTEM_CANCELLATION =
  "system_cancellation";
export const RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_AREA_UNAVAILABLE =
  "area_unavailable";
export const RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_OTHER = "other";

/**
 * @type {Record<import("../../types/rentalArea/Booking").RentalAreaBookingRefusalReason, {
 *  id: import("../../types/rentalArea/Booking").RentalAreaBookingRefusalReason;
 * label: import("react-intl").MessageDescriptor;
 * }>}
 */
export const RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS = {
  [RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_CUSTOMER_CANCELLATION]: {
    id: RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_CUSTOMER_CANCELLATION,
    label: defineMessage({ defaultMessage: "annulation du client" }),
  },
  [RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_SYSTEM_CANCELLATION]: {
    id: RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_SYSTEM_CANCELLATION,
    label: defineMessage({ defaultMessage: "annulation de notre part" }),
  },
  [RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_AREA_UNAVAILABLE]: {
    id: RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_AREA_UNAVAILABLE,
    label: defineMessage({ defaultMessage: "salle non disponible" }),
  },
  [RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_OTHER]: {
    id: RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_VALUE_OTHER,
    label: defineMessage({ defaultMessage: "autre" }),
  },
};

export const RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS_LIST = Object.values(
  RENTAL_AREAS_BOOKINGS_REFUSAL_REASONS,
);

/* Rental area booking sorts */
export const RENTAL_AREAS_BOOKINGS_SORT_CREATED_ASC = "created_asc";
export const RENTAL_AREAS_BOOKINGS_SORT_CREATED_DESC = "created_desc";
export const RENTAL_AREAS_BOOKINGS_SORT_START_ASC = "start_asc";
export const RENTAL_AREAS_BOOKINGS_SORT_START_DESC = "start_desc";

export const RENTAL_AREAS_BOOKINGS_SORTS = {
  [RENTAL_AREAS_BOOKINGS_SORT_CREATED_ASC]: {
    id: RENTAL_AREAS_BOOKINGS_SORT_CREATED_ASC,
    label: defineMessage({ defaultMessage: "date de création croissante" }),
  },
  [RENTAL_AREAS_BOOKINGS_SORT_CREATED_DESC]: {
    id: RENTAL_AREAS_BOOKINGS_SORT_CREATED_DESC,
    label: defineMessage({ defaultMessage: "date de création décroissante" }),
  },
  [RENTAL_AREAS_BOOKINGS_SORT_START_ASC]: {
    id: RENTAL_AREAS_BOOKINGS_SORT_START_ASC,
    label: defineMessage({ defaultMessage: "date de début croissante" }),
  },
  [RENTAL_AREAS_BOOKINGS_SORT_START_DESC]: {
    id: RENTAL_AREAS_BOOKINGS_SORT_START_DESC,
    label: defineMessage({ defaultMessage: "date de début décroissante" }),
  },
};

export const RENTAL_AREAS_BOOKINGS_SORTS_LIST = Object.values(
  RENTAL_AREAS_BOOKINGS_SORTS,
);
